<app-navbar *ngIf="showHeaderFooter"></app-navbar>
<router-outlet></router-outlet>
<app-footer *ngIf="showHeaderFooter"></app-footer>
<ngx-scrolltop></ngx-scrolltop>